import { tns } from 'tiny-slider'

// Function to set the phone field as required in the form when preferred contact method is set to phone
function setPhoneRequiredIfPreferred(){
    $("#inputContactMethod option:selected").each(function(){
        var contactMethod = $(this).val();        
        if(contactMethod == "Phone"){
            $(this).closest("form").find("#inputPhone").prop('required',true);
        }else if(contactMethod == "Email"){
            $(this).closest("form").find("#inputPhone").prop('required',false);
        }
    })
}

// Function to find multiline labels and adjust the input/textarea to prevent overlap/overflow
function findLabelOverflow (){
    $(".form-label-group label:not(.dropdown-label)").each(function(){
        var ow = $(this).outerWidth();
        var sw = $(this)[0].scrollWidth;
        var matchedInput = $("#" + $(this).attr("for"));
        matchedInput.css("padding-top", "");
        matchedInput.css("height", "");
        if(sw > ow || $(this).hasClass('multi-line-label')){
            $(this).addClass('multi-line-label');
            matchedInput.css("height", "");
            var labelHeight = $(this).height();
            var inputHeight = matchedInput.height();
            var contentHeight = matchedInput.get(0).scrollHeight;
            if(contentHeight > inputHeight){
                contentHeight = inputHeight;
            }
            matchedInput.css("padding-top", labelHeight);
            matchedInput.css("height", inputHeight * 2 + labelHeight);
        } 
    })
}
function findSelectLabelOverflow(){
    $(".form-label-group label.dropdown-label").each(function(){
        var ow = $(this).outerWidth();
        var sw = $(this)[0].scrollWidth;
        var matchedInput = $("#" + $(this).attr("for"));
        matchedInput.css("padding-top", "");
        matchedInput.css("height", "");

        if(matchedInput.hasClass('selected')){
            if(sw > ow || $(this).hasClass('multi-line-label')){
                $(this).addClass('multi-line-label');
                matchedInput.css("height", "");
                var labelHeight = $(this).height();
                var inputHeight = matchedInput.height();
                var contentHeight = matchedInput.get(0).scrollHeight;
                if(contentHeight > inputHeight){
                    contentHeight = inputHeight;
                }
                matchedInput.css("padding-top", labelHeight);
                matchedInput.css("height", inputHeight * 2 + labelHeight);
            } 
        } else {
            $(this).removeClass('multi-line-label')
        }
    })
}



$( document ).ready(function() {  
    // Handle phone field required dependant on preferred contact method selected (on load and on change)
    setPhoneRequiredIfPreferred();
    $( "#inputContactMethod" ).change(function() {
        setPhoneRequiredIfPreferred();
    });   
    // Handle multiline floating labels
    findLabelOverflow();
    findSelectLabelOverflow()
    $( window ).resize(function() {
        findLabelOverflow();
        findSelectLabelOverflow()
    })
    $(window).on('shown.bs.modal', function() { 
        findLabelOverflow();
        findSelectLabelOverflow()
    });

    $(document).on('change', ".form-label-group select", function(){
        //FLOATING LABEL SAFARI FIX
        val = $(this).find(":selected").val();
        if( typeof val != 'undefined' && val.length > 0 ){
            $(this).addClass('selected');
        } else {
            $(this).removeClass('selected');
        }

        // Floating Label Sizing
        findSelectLabelOverflow()
    })

    // Service Pack Request Accordion
    const accordion = $('#service-info-pack-accordion');
    accordion.find('.accordion-button').each(function () {
		$(this).on('click', function () {
            const thisBtn = $(this)
            accordion.find('.accordion-collapse').each(function () {
                //console.log(thisBtn.attr('data-bs-target').includes($(this).attr('id')))

                if(thisBtn.attr('data-bs-target').includes($(this).attr('id'))) {
                    //console.log(thisBtn.parent().siblings($(this).attr('data-bs-target')))
                    console.log($(this))
                    if($(this)[0].classList.contains('show')) {
                        $(this).collapse('hide');
                    } else {
                        $(this).collapse('show');
                    }
                } else {
                    $(this).collapse('hide');
                    //console.log(thisBtn.parent().siblings($(this).attr('data-bs-target')))
                }
            })
		})	
	})


});

function initAnon(form) {
    const anonRadioBtns = form.querySelectorAll('input[name="wishes_to_remain_anonymous"]');
    if(anonRadioBtns != null) {
        anonRadioBtns.forEach(anonSwitch => {
            setupAnon(form, anonSwitch, 'no-click');
            anonSwitch.addEventListener('click', _=> {
                setupAnon(form, anonSwitch, 'click')
            })
        });
    }
}

function setupAnon(form, anonSwitch, source) {
    let yesChecked = form.querySelector('input[name="wishes_to_remain_anonymous"][value="Yes"]:checked');
    if (anonSwitch.checked && anonSwitch.value == 'Yes') {
        form.querySelector('input[name="first_name"]').setAttribute('value', 'Anonymous');
        form.querySelector('input[name="last_name"]').setAttribute('value', 'Anonymous');
        form.querySelector('input[name="address"]').setAttribute('value', 'Anonymous Address');
        form.querySelector('input[name="email_address"]').setAttribute('value', 'Anonymous@example.com');
        form.querySelector('input[name="email_address_confirmation"]').setAttribute('value', 'Anonymous@example.com');
        form.querySelector('input[name="phone"]').setAttribute('value', '0000000000');
        form.querySelector('input[name="phone_confirmation"]').setAttribute('value', '0000000000');
        form.querySelector('select[name="preferred_contact_method"]').selectedIndex = 3;
        form.querySelector('input[name="first_name"]').disabled = true;
        form.querySelector('input[name="last_name"]').disabled = true;
        form.querySelector('input[name="address"]').disabled = true;
        form.querySelector('input[name="email_address"]').disabled = true;
        form.querySelector('input[name="email_address_confirmation"]').disabled = true;
        form.querySelector('input[name="phone"]').disabled = true;
        form.querySelector('input[name="phone_confirmation"]').disabled = true;
        form.querySelector('select[name="preferred_contact_method"]').disabled = true;
    } else if (yesChecked == null && source === 'click') {
        form.querySelector('input[name="first_name"]').setAttribute('value', '');
        form.querySelector('input[name="last_name"]').setAttribute('value', '');
        form.querySelector('input[name="address"]').setAttribute('value', '');
        form.querySelector('input[name="email_address"]').setAttribute('value', '');
        form.querySelector('input[name="email_address_confirmation"]').setAttribute('value', '');
        form.querySelector('input[name="phone"]').setAttribute('value', '');
        form.querySelector('input[name="phone_confirmation"]').setAttribute('value', '');
        form.querySelector('select[name="preferred_contact_method"]').selectedIndex = 0;
        form.querySelector('input[name="first_name"]').disabled = false;
        form.querySelector('input[name="last_name"]').disabled = false;
        form.querySelector('input[name="address"]').disabled = false;
        form.querySelector('input[name="email_address"]').disabled = false;
        form.querySelector('input[name="email_address_confirmation"]').disabled = false;
        form.querySelector('input[name="phone"]').disabled = false;
        form.querySelector('input[name="phone_confirmation"]').disabled = false;
        form.querySelector('select[name="preferred_contact_method"]').disabled = false;
    }

}

// Service pack form feedback version
document.addEventListener('DOMContentLoaded', _=> {
    const franchiseeFormSlider = document.querySelectorAll('.franchisee-form-slider-wrapper');
    franchiseeFormSlider.forEach(forms => {
        // Variable Init
        const seedNumber = forms.querySelector('.feedback-seed').getAttribute('data-seed-number');
        const feedBackForm = forms.querySelector('.feed-back-form-' + seedNumber);
        const btns = forms.querySelectorAll('.accordion-button');
        const accordionBox = forms.querySelector('.franchisee-accordion-wrapper');

        // Slider Init
        const slider = tns({
            container: forms.querySelector('.franchisee-form-slider'),
            navContainer: forms.querySelector('.franchisee-form-slider-nav'),
            items: 1,
            slideBy: 1,
            arrowKeys: false,
            nav: true,
            controls: false,
            autoHeight: true,
            edgePadding: 5,
            gutter: 30,
            preventScrollOnTouch: 'auto',
            loop: false,
            touch: false,
        });

        // accordion btn init
        btns.forEach(btn => {
            btn.addEventListener('click', _=> {
                if(accordionBox.classList.contains('show') && btn.classList.contains('tns-nav-active')) {
                    $(accordionBox).collapse('hide')
                    slider.updateSliderHeight();
                } else {
                    $(accordionBox).collapse('show')
                    slider.goTo(btn.getAttribute('data-nav'))
                    slider.updateSliderHeight();
                }
            })
        })

        const franchiseFeedbackAnchorPresent = window.location.hash == '#franchisee-feedback';
        const franchiseEnquiryAnchorPresent = window.location.hash == '#franchisee-form';
        if (franchiseFeedbackAnchorPresent) {
            $(accordionBox).collapse('show')
            slider.goTo(0)
            slider.updateSliderHeight();
            window.scrollTo({ 
                top: document.querySelector('.franchisee-accordion-wrapper').getBoundingClientRect().top + window.scrollY - 100,
                left: 0,
                behavior: 'smooth'
            });
        } else if (franchiseEnquiryAnchorPresent) {
            $(accordionBox).collapse('show')
            slider.goTo(1)
            slider.updateSliderHeight();
            window.scrollTo({ 
                top: document.querySelector('.franchisee-accordion-wrapper').getBoundingClientRect().top + window.scrollY - 100,
                left: 0,
                behavior: 'smooth'
            });
        } else {
            // on init hide accordion after load
            $(accordionBox).collapse('hide');
        }

        initAnon(feedBackForm)
    });
    
    const generalFeedbackForms = document.querySelectorAll('.general-feedback-form');

    generalFeedbackForms.forEach(form => {
        initAnon(form)
    })
})